/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Ip_TitleInputs */

const fr_legal_ip_title = /** @type {(inputs: Legal_Ip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriété Intellectuelle`)
};

const en_legal_ip_title = /** @type {(inputs: Legal_Ip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intellectual property`)
};

/**
* | output |
* | --- |
* | "Intellectual property" |
*
* @param {Legal_Ip_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_ip_title = /** @type {((inputs?: Legal_Ip_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Ip_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_ip_title(inputs)
	return en_legal_ip_title(inputs)
});